<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    errorMessages?: string | string[];
    readonly?: boolean;
    disabled?: boolean;
    hideDetails?: boolean | string;
    label?: string;
    placeholder?: string;
    itemValue?: string;
    itemTitle?: string;
    truncate?: number; // max characters for truncation; 0 = no truncation
    tooltip?: boolean; // show full title on hover
  }>(),
  {
    errorMessages: () => [],
    readonly: false,
    disabled: false,
    label: '',
    placeholder: '',
    itemValue: '',
    itemTitle: '',
    hideDetails: 'auto',
    truncate: 0,
    tooltip: false,
  }
);

const select = defineModel<string | number>();

function getItemRawTitle(item: any): string {
  const raw = (item && (item as any).raw) ? (item as any).raw : item;
  if (raw == null) return '';
  if (typeof raw === 'string') return raw;
  if (props.itemTitle && typeof (raw as any)[props.itemTitle] !== 'undefined') {
    const val = (raw as any)[props.itemTitle];
    return typeof val === 'string' ? val : String(val ?? '');
  }
  return String(raw.title ?? '');
}

function truncateText(text: string, max: number): string {
  if (!max || max <= 0) return text || '';
  const str = (text ?? '').toString();
  return str.length > max ? str.slice(0, max) + '...' : str;
}
</script>
<template>
  <v-select
    v-model="select"
    flat
    variant="solo-filled"
    :item-value="itemValue"
    :item-title="itemTitle"
    :hide-details="hideDetails"
    :error-messages="errorMessages"
    :placeholder="placeholder"
    :label="label"
    :readonly="readonly"
    :disabled="disabled"
  >
    <template v-if="truncate || tooltip" #item="{ props: itemProps, item }">
      <v-list-item v-bind="itemProps" :title="tooltip ? getItemRawTitle(item) : undefined">
        <template #title>
          {{ truncate ? truncateText(getItemRawTitle(item), truncate) : getItemRawTitle(item) }}
        </template>
      </v-list-item>
    </template>
    <template v-if="truncate || tooltip" #selection="{ item }">
      <span :title="tooltip ? getItemRawTitle(item) : undefined">
        {{ truncate ? truncateText(getItemRawTitle(item), truncate) : getItemRawTitle(item) }}
      </span>
    </template>
  </v-select>
</template>

<style></style>
